import { useSelector, useDispatch } from 'react-redux';
import {
  changeDateRange,
  handleLobFilterChange,
  handleTeamFilterChange,
  handleAgentFilterChange,
  handleSetExtraFilterData,
  handleRemoveExtraFilterData,
  handleSetMultipleExtraFilterData,
  handleRemoveMultipleExtraFilterData,
  handleSetMultipleFeatureFilterData,
  handleRemoveFeatureExtraFilterData,
  clearExtraFilter,
  handleChangeAddtionalFields,
  handleChangeAddtionalSubFields,
  setAllfilterFromParent,
  setExtraFilter,
  setFeatureFilter,
  clearFeatureFilter,
  getEvaluationConfigData,
  clearLobTeamAgent,
  handleRemoveMultipleExtraFilterDataFromApplied,
  handleRemoveMultipleFeatureFilterDataFromApplied,
  setSelectedDatafromParent,
  handleLobAllFilterChange,
  handleAllTeamFilterChange,
  handleAllAgentFilterChange,
  handleSetMultipleSelectFilterData,
  handleRemoveMultipleSelectFilterData,
  handleSetFeatureAttributeData,
  getEvaluationTeamFeatureData,
  handleshown
} from 'store/EvaluationFilter';
import { selectFeatureFilter, selectorForSelectedFilter } from 'store/EvaluationFilter/selector';

function useEvaluationFilter() {
  const dispatch = useDispatch();

  const dateRange = useSelector((state) => state.evaluationfilter.rangeDate),
    LOB = useSelector((state) => state.evaluationfilter.LOB),
    ui = useSelector((state) => state.evaluationfilter.ui),
    LOBTeam = useSelector((state) => state.evaluationfilter.LOBTeam),
    LOBTeamAgent = useSelector((state) => state.evaluationfilter.LOBTeamAgent),
    flag = useSelector((state) => state.evaluationfilter.flag),
    shown = useSelector((state) => state.evaluationfilter.shown),
    filter = useSelector((state) => state.evaluationfilter.data),
    filters = useSelector((state) => state.evaluationfilter.data?.extra_filter),
    appliedExtraFilters = useSelector((state) => state.evaluationfilter.extra_filter),
    appliedFeatureFilters = useSelector((state) => state.evaluationfilter.features_filter),
    features_filter = useSelector(selectFeatureFilter),
    selectedFilter = useSelector(selectorForSelectedFilter),
    selectedFields = useSelector((state) => state.evaluationfilter.selected?.fields),
    SelectedLOBTeam = useSelector((state) => state?.evaluationfilter?.selected?.LOBTeam),
    selectedRowFilterFields = useSelector((state) => state.evaluationfilter.selected?.rowFilter),
    filterFields = useSelector((state) => state.evaluationfilter.fields),
    call_duration = useSelector((state) => state.evaluationfilter.data?.extra_filter?.call_duration),
    tenure = useSelector((state) => state.evaluationfilter.data?.extra_filter?.tenure),
    shift = useSelector((state) => state.evaluationfilter.data?.extra_filter?.shift),
    direction = useSelector((state) => state.evaluationfilter.data?.extra_filter?.direction),
    skill_set = useSelector((state) => state.evaluationfilter.data?.extra_filter?.skill_set),
    tagging_feature = useSelector((state) => state.evaluationfilter.data?.extra_filter?.tagging_feature),
    exo_phone = useSelector((state) => state.evaluationfilter.data?.extra_filter?.exo_phone),
    fieldsConfig = useSelector((state) => state.evaluationfilter.fields_config),
    TeamFeatureData = useSelector((state) => state?.evaluationfilter?.TeamFeatureData);

  const changeDateRangeAction = (params) => dispatch(changeDateRange(params)),
    handleLobFilterChangeAction = (params) => dispatch(handleLobFilterChange(params)),
    handleTeamFilterChangeAction = (params) => dispatch(handleTeamFilterChange(params)),
    handleAgentFilterChangeAction = (params) => dispatch(handleAgentFilterChange(params)),
    handleSetExtraFilterDataAction = (params) => dispatch(handleSetExtraFilterData(params)),
    handleRemoveExtraFilterDataAction = (params) => dispatch(handleRemoveExtraFilterData(params)),
    handleSetMultipleExtraFilterDataAction = (params) => dispatch(handleSetMultipleExtraFilterData(params)),
    handleRemoveMultipleExtraFilterDataAction = (params) => dispatch(handleRemoveMultipleExtraFilterData(params)),
    handleRemoveMultipleExtraFilterDataFromAppliedAction = (params) => dispatch(handleRemoveMultipleExtraFilterDataFromApplied(params)),
    handleRemoveMultipleFeatureFilterDataFromAppliedAction = (params) => dispatch(handleRemoveMultipleFeatureFilterDataFromApplied(params)),
    handleSetMultipleFeatureFilterDataAction = (params) => dispatch(handleSetMultipleFeatureFilterData(params)),
    handleRemoveFeatureExtraFilterDataAction = (params) => dispatch(handleRemoveFeatureExtraFilterData(params)),
    handleChangeAddtionalFieldsAction = (params) => dispatch(handleChangeAddtionalFields(params)),
    handleChangeAddtionalSubFieldsAction = (params) => dispatch(handleChangeAddtionalSubFields(params)),
    setAllfilterFromParentAction = (params) => dispatch(setAllfilterFromParent(params)),
    setSelectedDatafromParentAction = (params) => dispatch(setSelectedDatafromParent(params)),
    setFeatureFilterAction = (params) => dispatch(setFeatureFilter(params)),
    setExtraFilterAction = () => dispatch(setExtraFilter()),
    clearExtraFilterAction = () => dispatch(clearExtraFilter()),
    clearFeatureFilterAction = () => dispatch(clearFeatureFilter()),
    clearLobTeamAgentAction = () => dispatch(clearLobTeamAgent()),
    getEvaluationConfigDataAction = () => dispatch(getEvaluationConfigData()),
    handleLobAllFilterChangeAction = () => dispatch(handleLobAllFilterChange()),
    handleAllTeamFilterChangeAction = () => dispatch(handleAllTeamFilterChange()),
    handleAllAgentFilterChangeAction = () => dispatch(handleAllAgentFilterChange()),
    handleSetMultipleSelectFilterDataAction = (params) => dispatch(handleSetMultipleSelectFilterData(params)),
    handleRemoveMultipleSelectFilterDataAction = (params) => dispatch(handleRemoveMultipleSelectFilterData(params)),
    handleSetFeatureAttributeDataAction = (params) => dispatch(handleSetFeatureAttributeData(params)),
    getEvaluationTeamFeatureDataAction = (params) => dispatch(getEvaluationTeamFeatureData(params)),
    handleshownAction = (params) => dispatch(handleshown(params));
  return {
    // state of Filter
    dateRange,
    LOB,
    ui,
    LOBTeam,
    LOBTeamAgent,
    flag,
    filter,
    filters,
    features_filter,
    selectedFilter,
    selectedFields,
    SelectedLOBTeam,
    selectedRowFilterFields,
    call_duration,
    tenure,
    shift,
    direction,
    skill_set,
    tagging_feature,
    exo_phone,
    filterFields,
    fieldsConfig,
    appliedExtraFilters,
    appliedFeatureFilters,
    TeamFeatureData,
    shown,

    // Action of Filter

    changeDateRangeAction,
    handleLobFilterChangeAction,
    handleTeamFilterChangeAction,
    handleAgentFilterChangeAction,
    handleChangeAddtionalFieldsAction,
    handleChangeAddtionalSubFieldsAction,
    handleSetExtraFilterDataAction,
    handleRemoveExtraFilterDataAction,
    handleSetMultipleExtraFilterDataAction,
    handleRemoveMultipleExtraFilterDataAction,
    handleSetMultipleFeatureFilterDataAction,
    handleRemoveFeatureExtraFilterDataAction,
    handleRemoveMultipleExtraFilterDataFromAppliedAction,
    handleRemoveMultipleFeatureFilterDataFromAppliedAction,
    setAllfilterFromParentAction,
    setSelectedDatafromParentAction,
    setFeatureFilterAction,
    setExtraFilterAction,
    clearExtraFilterAction,
    clearFeatureFilterAction,
    clearLobTeamAgentAction,
    getEvaluationConfigDataAction,
    handleLobAllFilterChangeAction,
    handleAllTeamFilterChangeAction,
    handleAllAgentFilterChangeAction,
    handleSetMultipleSelectFilterDataAction,
    handleRemoveMultipleSelectFilterDataAction,
    handleSetFeatureAttributeDataAction,
    getEvaluationTeamFeatureDataAction,
    handleshownAction
  };
}

export default useEvaluationFilter;
